export enum CognitoUserCustomAttributes {
  FULL_NAME = "custom:full_name",
  POSTCODE = "custom:postcode"
}

export const REACT_QUERY_AUTH_REQUIRED_KEY = "authRequired";
export const REACT_QUERY_USER_PROFILE_KEY = "userProfile";

export interface CognitoUserData {
  username: string;
  attributes?: {
    [CognitoUserCustomAttributes.FULL_NAME]: string;
    given_name: string;
    family_name: string;
    email: string;
    email_verified: boolean;
    phone_number?: string;
    phone_number_verified?: boolean;
    [CognitoUserCustomAttributes.POSTCODE]?: string;
  };
}

export interface UserData {
  username?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  mobile?: string;
  postcode?: string;
}

export enum AccountDonationRecurrence {
  SINGLE = "Single",
  DAILY = "Daily",
  WEEKLY = "Weekly",
  MONTHLY = "Monthly"
}

export enum AccountDonationType {
  SADAQAH = "Sadaqah",
  ZAKAT = "Zakat",
  TAINTED_WEALTH = "Tainted Wealth",
  FIDYAH = "Fidyah",
  FITR = "Fitr",
  QURBAN = "Qurban",
  OTHER = "Other",
  MULTI = "Multi"
}

export enum AccountDonationDonorType {
  INDIVIDUAL = "Individual",
  ORGANISATION = "Organisation",
  BEHALF_OF = "Behalf Of"
}

export enum AccountPaymentMethodType {
  CARD = "Card",
  BANK = "Bank",
  OFFLINE = "Offline",
  PAYPAL = "PayPal"
}

export enum StripeWalletType {
  APPLE_PAY = "apple_pay",
  GOOGLE_PAY = "google_pay",
  LINK = "link"
}

export interface CardPaymentMethodDetails {
  type: AccountPaymentMethodType.CARD;
  lastFourDigits?: string | null;
  expiryMonth?: number | null;
  expiryYear?: number | null;
  brand?: string | null;
  country?: string | null;
  wallet?: StripeWalletType | string | null;
}

export interface BankPaymentMethodDetails {
  type: AccountPaymentMethodType.BANK;
  bsbNumber?: string | null;
  lastFourDigits?: string | null;
}

export interface PayPalPaymentMethodDetails {
  type: AccountPaymentMethodType.PAYPAL;
}

export type AccountPaymentMethodDetails =
  CardPaymentMethodDetails | BankPaymentMethodDetails | PayPalPaymentMethodDetails;

export enum AccountDonationStatus {
  PENDING = "Pending",
  COMPLETED = "Completed"
}

export enum AccountRecurringDonationStatus {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
  SCHEDULED = "Scheduled"
}

export enum AccountDonationSource {
  STRIPE = "Stripe",
  PAYPAL = "PayPal",
  OFFLINE = "Offline Bank Transfer",
  LAUNCHGOOD = "Launchgood",
  EZIDEBIT = "Ezidebit"
}

export enum AccountRecurringDonationPlan {
  DAILY = "Daily",
  WEEKLY = "Weekly",
  MONTHLY = "Monthly",
  JUMUAH_GIVING = "Jumuah Giving",
  RAMADAN_DAILY = "Ramadan Daily",
  DHUL_HIJJAH_DAILY = "Dhul Hijjah Daily"
}

export enum AccountSubscriptionPeriod {
  FIRST_TEN_NIGHTS = "firstTenNights",
  SECOND_TEN_NIGHTS = "secondTenNights",
  LAST_ODD_NIGHTS_1 = "lastOddNights1",
  LAST_ODD_NIGHTS_2 = "lastOddNights2",
  LAST_EVEN_NIGHTS = "lastEvenNights",
  TWENTY_SEVENTH_NIGHT = "twentySeventhNight",
  NZF_SUPPORT = "nzfSupport",
  TEN_DAYS = "tenDays",
  INDEFINITE = "indefinite",
  ONE_TIME = "oneTime"
}

export interface AccountDonationLineItem {
  id: string;
  amount: number;
  behalfOf: string | null;
  donorType: AccountDonationDonorType;
  donationType: AccountDonationType;
  program: string;
}

export interface AccountDonation {
  id: string;
  userId: string;
  providedEmail: string;
  providedFirstName: string | null;
  providedLastName: string | null;
  providedMobile: string | null;
  providedPostcode: string | null;
  behalfOf: string | null;
  donorType: AccountDonationDonorType | null;
  amount: number;
  nzfSupportAmount: number;
  transactionFee: number;
  isAbsorbingFees: boolean;
  donationType: AccountDonationType;
  program: string | null;
  recurrence: AccountDonationRecurrence;
  recurringDonationId: string | null;
  paymentMethod: AccountPaymentMethodType;
  referenceId: string;
  source: AccountDonationSource;
  status: AccountDonationStatus;
  donationTimestamp: string;
  lines: AccountDonationLineItem[];
  createdAt: string;
  updatedAt: string;
}
